/**
 * Application Configuration
 * Centralizes environment variables and application-wide settings.
 */

const config = {
  // API Configuration
  apiBaseUrl: process.env.REACT_APP_APIBASEURL || "",
  voiceApiBaseUrl: process.env.REACT_APP_APIBASEURL || "",

  // Feature Flags
  features: {
    enableVoice:
      String(process.env.REACT_APP_ENABLE_VOICE).trim().toLowerCase() ===
      "true",
  },

  // Environment info
  env: process.env.NODE_ENV || "development",
  isProduction: process.env.NODE_ENV === "production",

  // Twilio Specific Configs
  twilio: {
    // Add any specific Twilio client-side config here if needed (e.g., region)
    region: process.env.REACT_APP_TWILIO_REGION || "us1",
  },
};

export default config;
